import React from "react";
import moment from "moment-mini";
import Image from "next/image";
import classNames from "classnames";
import Link from "next/link";
import RegisterDocument from "./RegisterDocument";
import newsLang from "../../i18n/news";
import styles from "./NewsSidebar.module.scss";

const NewsSidebar = ({ hotNews, locale, bannerUrl, bannerLink, linkedin }) => {
  return (
    <>
      <div className="mb-5">
        <Link href={bannerLink || "/"}>
          <a>
            <Image
              src={
                bannerUrl
                  ? process.env.NEXT_PUBLIC_MEDIA_FILE + bannerUrl
                  : "/static/banner-sidebar.jpg"
              }
              width={350}
              height={425}
              layout="responsive"
            />
          </a>
        </Link>
      </div>
      <div className="d-none d-md-block d-lg-none mb-5">
        <RegisterDocument locale={locale} className="px-5" />
      </div>
      <div className="d-block d-md-none d-lg-block mb-5">
        <RegisterDocument locale={locale} vertical />
      </div>
      <div className="mb-5">
        <iframe
          src={linkedin?.data[0]?.data_info?.link}
          height="500"
          width="100%"
          frameBorder="0"
          allowFullScreen=""
          title="Embedded post"
        />
      </div>
      <div className={classNames("border p-3", styles.featuredPosts)}>
        <h5 className="text-uppercase font-weight-bold text-blue mb-3 mt-2">
          {newsLang.sidebar.featuredPosts[locale]}
        </h5>
        {hotNews?.data?.length > 0 ? (
          hotNews?.data?.map((item, index) => (
            <div key={item.id.toString()}>
              <small>
                {moment(item.created_at).format(
                  locale === "vi" ? "DD/MM/YYYY" : "DD MMMM YYYY"
                )}
              </small>
              <h6 className="mb-4 mt-2">
                <Link
                  as={`/news/${item.slug?.substring(0, item.slug.length - 9)}-${
                    item.id
                  }`}
                  href={`/news/${item.id}`}
                >
                  <a className={styles.newsLink}>{item.title}</a>
                </Link>
              </h6>
              {index < hotNews.data.length - 1 && <hr />}
            </div>
          ))
        ) : (
          <span>{newsLang.sidebar.emptyNews[locale]}</span>
        )}
      </div>
    </>
  );
};

export default NewsSidebar;
